export default "__VITE_ASSET__DuoEunsY__"